import { useEffect, useState } from 'react';
import ChatInput from '../../../components/shared/chat-input/ChatInput';
import StayUpdated from '../../../components/shared/stay-updated/StayUpdated';
import ChatContent from '../chats/ChatContent';
import LogoHomepage from '../../../components/shared/logo-homepage/LogoHomepage';
import { classNames } from '../../../utils/classNames';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { showChatInput } from '../../../store/slices/chats.slice';

const Homepage = () => {
	const [isChatting, setIsChatting] = useState<boolean>(false);
	const handleShowChatting = () => setIsChatting(true);
	const [searchParams] = useSearchParams();
	const newChat = searchParams.get('newChat');
	const dispatch = useDispatch();

	useEffect(() => {
		if (newChat) {
			dispatch(showChatInput(true));
		}
	}, [newChat])

    return (
        <div className=' justify-center items-center pt-8 mx-auto mt-auto'>
			<div className={classNames('mb-5', isChatting ? 'h-[80vh] md:h-[calc(100vh-300px)]' : 'h-0')}>
				{(isChatting || newChat) && <ChatContent isFromHomepage={true}/>}
			</div>
			{((isChatting) || !isChatting) && <ChatInput onSend={handleShowChatting} />}
			{!isChatting && <StayUpdated />}
			{!isChatting && <LogoHomepage />}
        </div>
    )
}

export default Homepage;